const selectors = {
  productContainer: document.querySelector('.product-details-wrapper'),
  productMedia: document.querySelector('[data-productMedia]')
};
var selectedVariants = [];
var firstArrayForFirstError = [];
var secondArrayForFirstError = [];
var firstArrayForSecondError = [];
var secondArrayForSecondError = [];
var exist_in_first_array = false;
var exist_in_second_array = false;
var exist_in_third_array = false;
var exist_in_forth_array = false;
var headerEleHeight;
var cylindoViewers;
var cylindoFeature;

const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
window.productMedia = mediaJSON;

class TemplateProductJS {
  constructor() {
    
    //addon checkbox event
    if (document.querySelectorAll("[data-addon-checkbox]").length > 0) {
      
      document.querySelectorAll("[data-addon-checkbox]").forEach(ele=>{
        ele.addEventListener("change" , (event)=>{
          cylindoViewers = document.querySelectorAll('cylindo-viewer');
          this._updateSlider(event);
          this._checkAddon(event);
         
        });
      })
    };

    //check zip code 
    if (document.querySelector("[data-zip]")) {
      document.querySelector('[data-zip]').addEventListener("click" , (event)=>{
        this.validateZipcode(event);
      });
    }

    //show zip code box
    if(document.querySelector("[data-show-zip-code-box]")){
      document.querySelector("[data-show-zip-code-box]").addEventListener("click" , (event)=>{
        this._showZipCodeBox(event);
      })
    };

    //reset zip code
    if(document.querySelector("[data-zip-reset]")){
      document.querySelector("[data-zip-reset]").addEventListener("click" , (event)=>{
        event.preventDefault();
        this._resetZipCode();
      })
    };

    this._getMetafieldValue();
    const url = new URL(window.location.href);
     
     if(window.location.search && url.searchParams.has('title') ){
      let search = decodeURIComponent(window.location.search.replace("?title=",""));
      if(document.querySelector("[data-selected-option]")){
        document.querySelector("[data-selected-option]").innerText = search;
      }
      
     }
     if(window.innerWidth > 1999){
     // Log the dynamic distance
        window.addEventListener('scroll', () => {
          const element = document.querySelector('#productTabs');
          const rect = element.getBoundingClientRect();
          let headerEle = document.querySelector("[data-sticky-type]").offsetHeight;
          headerEle = headerEle + 1;
          if(headerEle >= rect.top){
            document.querySelector(".sticky-add-to-cart").classList.add('button-sticky');
          }else{
            document.querySelector(".sticky-add-to-cart").classList.remove('button-sticky');
          }
        });
      }
     this.init();
 
  }

  init(){

    cylindoViewers = document.querySelectorAll('cylindo-viewer');
    cylindoFeature = document.querySelector("[cylindoFeature]").innerText;

    let featuresState = {};
    if (cylindoFeature){
      featuresState[cylindoFeature] = "ON";
    }

    let features = featuresState ? featuresState : {};

    // Check if viewer exists and update features for each viewer
    if (cylindoViewers.length === 0) return;
    cylindoViewers.forEach(viewer => {
      viewer.features = features;
    });
  }

//   _updateSlider(event){
//     const checkboxes = document.querySelectorAll("[data-addon-checkbox]");
// const checkedCount = Array.from(checkboxes).filter(checkbox => checkbox.checked).length;

// console.log(`Checked checkboxes: ${checkedCount}`);

//     let current_feature;
//     let current_ele = event.currentTarget;
//     let variant_id = current_ele.value;
//     if (document.querySelector("[cylindro_features]")) {
//       let featureEle = document.querySelector("[cylindro_features]").textContent;
//       let featureJson =  JSON.parse(featureEle);
//       console.log("F",featureJson)
//        current_feature = featureJson.find(featureJson =>featureJson.variant_id == variant_id);
//       console.log("features" , featureJson , current_feature);
//     }
   
//     let features = current_feature.feature;
//     if(checkedCount == 0){
//       features = {};
//    }
   
//     console.log("ferwrtue", features)
   
//     // check if viewer exist
//     if (!features || cylindoViewers.length === 0) return;

//     // assign features
//     cylindoViewers.forEach(viewer => {
//       viewer.features = features;
//       console.log(`new features:`, features);
//     });
//   }
// _updateSlider(event) {
//   // Get all checkboxes and count how many are checked
//   const checkboxes = document.querySelectorAll("[data-addon-checkbox]");
//   const checkedCount = Array.from(checkboxes).filter(checkbox => checkbox.checked).length;
//   console.log(`Checked checkboxes: ${checkedCount}`);

//   // Initialize variables
//   let currentFeature={};
//   const currentElement = event.currentTarget;
//   const variantId = currentElement.value;


//   if (currentElement.hasAttribute("feature") && currentElement.checked) {
//     let feature = currentElement.getAttribute('feature');
//      currentFeature = { [feature]: "ON" };
    
//   }

//   // Extract features or reset to an empty object if no checkboxes are checked
//   let features = currentFeature ? currentFeature : {};
//   // if (checkedCount === 0) {
//   //   features = {};
//   // }

//   console.log("Final Features:", features);

//   // Check if viewer exists and update features for each viewer
//   if (cylindoViewers.length === 0) return;

//   cylindoViewers.forEach(viewer => {
//     viewer.features = features;
//     console.log("Updated Viewer Features:", features);
//   });
  
//   viewer.item = { viewerItemIndex: 1 };
// }
_updateSlider(event) {
  // Get all checkboxes and count how many are checked
  const checkboxes = document.querySelectorAll("[data-addon-checkbox]");
  const checkedCount = Array.from(checkboxes).filter(checkbox => checkbox.checked).length;
  let featuresState = {};

  if (cylindoFeature){
    featuresState[cylindoFeature] = "ON";
  }


  checkboxes.forEach(currentElement => {
    if (currentElement.hasAttribute("feature") && currentElement.checked) {
      let feature = currentElement.getAttribute('feature');
      featuresState[feature] = "ON"; // Store the feature and its state
    }
  });

  // Initialize variables
  let currentFeature={};
  const currentElement = event.currentTarget;
  const variantId = currentElement.value;
  


  let features = featuresState ? featuresState : {};


  console.log("Final Features:", features);

  // Check if viewer exists and update features for each viewer
  if (cylindoViewers.length === 0) return;
    cylindoViewers.forEach(viewer => {
      viewer.features = features;
    });
    viewer.item = { viewerItemIndex: 1 };
}





      
  _checkAddon(event){
    let productPrice = (window.globalVariables.product.price/100);
    let total = 0;
    selectedVariants = [];
    let count = 0;
    let is_installtion_added = false;

    if(document.querySelector("[data-installation-checkbox]") && document.querySelector("[data-installation-checkbox]").checked ){
      let is_installtion_added = true;
     
      document.querySelectorAll("[data-addon-checkbox]").forEach((ele) => {
        const accessoryWrap = ele.closest("[data-accessories-wrap]");
        const priceAttr = ele.getAttribute("data-intallation-price");
        const installationId = ele.getAttribute("data-installation-id");
        const isInstallationAvailable = ele.getAttribute("data-installation-available") == "true";
        let addonPrice;   
        // Reset accessory wrap visibility and selection
        if (accessoryWrap) {
          accessoryWrap.classList.remove("d-none", "choose-selected");
        }
        if(priceAttr){
           addonPrice = parseFloat(priceAttr.replace(/,/g, ""));
          if (accessoryWrap) {
            accessoryWrap.classList.add("choose-selected");
            const priceElement = accessoryWrap.querySelector("[data-currentprice] [data-accessory-price]");
            if (priceElement) {
              priceElement.innerText = `$${priceAttr}`;
            }
          }
        }
      
        if (ele.checked) {
          if (installationId && isInstallationAvailable) {
            count++;
            total += addonPrice;
            selectedVariants.push(parseInt(installationId));
          } else if (accessoryWrap) {
            ele.checked = false;
            accessoryWrap.classList.add("d-none");
          } 
          if (ele.hasAttribute("data-installation-checkbox")) {
            total += parseFloat(priceAttr.replace(/,/g, ""));
          }
        } else if (!installationId && accessoryWrap) {
          ele.checked = false;
          accessoryWrap.classList.add("d-none");
        }
      });
      
      if(count == 0){
        if(document.querySelector('[data-accessories-title]'))document.querySelector('[data-accessories-title]').classList.add("d-none");
      }

    }else{
    total = productPrice;

    document.querySelectorAll("[data-addon-checkbox]").forEach((ele) => {
      const accessoryWrap = ele.closest("[data-accessories-wrap]");
      const price = ele.getAttribute("data-accessory-price");
      if (accessoryWrap && accessoryWrap.querySelector("[data-currentprice] [data-accessory-price]")) {
        const priceElement = accessoryWrap.querySelector("[data-currentprice] [data-accessory-price]");
        if (priceElement) {
          priceElement.innerText = `$${price}`;
        }
      }
      // Reset accessory wrap visibility and selection
      if (accessoryWrap) {
        accessoryWrap.classList.remove("d-none", "choose-selected");
      }

      // Process checked addons
      if (ele.checked) {
        if (accessoryWrap) {
          accessoryWrap.classList.add("choose-selected");
        }
        const addonPrice = parseFloat(price.replace(/,/g, ""));
        total += addonPrice;

        const variantId = parseInt(ele.getAttribute("data-accessory-id"));
        selectedVariants.push(variantId);
      }
    });

  }
    const formattedNumber = total.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    document.querySelectorAll("[cart-total]").forEach(ele=>{
      ele.innerHTML = `$${formattedNumber}`;
    })

    if(is_installtion_added == true){
     
      if(document.querySelector("[data-assembly-element]")){
        let propertyValue = document.querySelector("[data-assembly-element]").getAttribute('data-product_assembly_handle');
        if(document.querySelectorAll("[data-assembly-property]").length > 0){
          document.querySelectorAll("[data-assembly-property]").forEach(ele=>{
            ele.value = propertyValue;
          })
        }
      }

    }else{
     
      if(document.querySelector("[data-assembly-element]")){
        let propertyValue = document.querySelector("[data-assembly-element]").getAttribute('data-product_handle');
        if(document.querySelectorAll("[data-assembly-property]").length > 0){
          document.querySelectorAll("[data-assembly-property]").forEach(ele=>{
            ele.value = propertyValue;
          })
        }
      }
    }
    this._checkCombination();
    // if (current_ele.checked) {
    //   this.setupSlider(current_ele);
    // }
   

  };

  _showZipCodeBox(event){
    event.preventDefault();
    event.currentTarget.classList.add("d-none")
    document.querySelector("[data-zip-code-box]").classList.remove("d-none");
    document.querySelector("[data-zip-code-box]").classList.add("d-sm-flex");
    // document.querySelector("[data-zip-reset]").classList.remove("d-none");
  };


  validateZipcode(event){
    let current_ele = event.currentTarget;
    current_ele.setAttribute('disabled', true);
    current_ele.classList.add('loading');
    let zipcode = document.querySelector("[zip-value]").value;
    zipcode = zipcode.trim();

    if(zipcode == ''){
      window.notificationEle.updateNotification('Zip Code', "Please enter a zipcode", {
        type: 'error',
        timeout: 5000
    });
    document.querySelector("[zip-value]").value='';
    current_ele.removeAttribute('disabled');
    current_ele.classList.remove('loading');
    return

    }else{
      window.globalVariables.zipcode = zipcode;


      fetch('https://dev.bypboh.com/api/zipcode', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "postal_code": `${zipcode}`,
          "brand": "Yardistry"
        })
      })
      .then(response => response.json())
      .then(response=>{  
        if (response.status == false) {
          window.globalVariables.installation_available = false;
          
        
          current_ele.removeAttribute('disabled');
          current_ele.classList.remove('loading');
          this._resetZipCode();
          document.querySelector("[data-installation-not-available]").classList.remove("d-none");
         
          document.querySelector("[data-show-zip-code-box]").classList.add("d-none");
          document.querySelector("[data-zip-reset]").classList.remove("d-none");
          document.querySelector("[data-installation-checkbox]").setAttribute("disabled","true");
          if (document.querySelector("[data-installation-checkbox]").checked) {
            document.querySelector("[data-installation-checkbox]").checked = false;
          }
        
        }else{
          
         this._resetZipCode();
         document.querySelector("[data-show-zip-code-box]").classList.add("d-none");
         document.querySelector("[data-zip-reset]").classList.remove("d-none");
         document.querySelector("[data-installation-available]").classList.remove("d-none");
         document.querySelector("[data-installation-checkbox]").removeAttribute("disabled");
         document.getElementById('installCheck').classList.remove('d-none');
         window.globalVariables.installation_available = true;
         
    }
        
    }).catch((e) => {
      window.globalVariables.installation_available = false;
          
        
      current_ele.removeAttribute('disabled');
      current_ele.classList.remove('loading');
      this._resetZipCode();
      document.querySelector("[data-installation-not-available]").classList.remove("d-none");
     
      document.querySelector("[data-show-zip-code-box]").classList.add("d-none");
      document.querySelector("[data-zip-reset]").classList.remove("d-none");
      document.querySelector("[data-installation-checkbox]").setAttribute("disabled","true");
      if (document.querySelector("[data-installation-checkbox]").checked) {
        document.querySelector("[data-installation-checkbox]").checked = false;
      }
    console.error(e);
    })
    .finally(() => {
    current_ele.classList.remove('loading');
    current_ele.removeAttribute('disabled');
   
    });
    
    document.querySelector("[zip-value]").value='';
    }
  };

  _resetZipCode(){
    document.querySelector("[data-zip-reset]").classList.add("d-none"); 
    document.querySelector("[data-show-zip-code-box]").classList.remove("d-none");
    document.querySelector("[data-zip-code-box]").classList.add("d-none");
    document.querySelector("[data-zip-code-box]").classList.remove("d-md-flex");
    document.querySelector("[data-installation-available]").classList.add("d-none");
    document.querySelector("[data-installation-not-available]").classList.add("d-none");
    if (document.querySelector("[data-installation-checkbox]").checked) {
      document.querySelector("[data-installation-checkbox]").click();
    }
    document.querySelector("[data-installation-checkbox]").setAttribute("disabled","true");
    document.getElementById('installCheck').classList.add('d-none');
    document.querySelector("[data-installation-checkbox]").checked = false;
    window.globalVariables.installation_available = false;
  };

 
  _checkCombination() {
    if (selectedVariants.length > 0) {
        let exist = {
            first: false,
            second: false,
            third: false,
            fourth: false
        };

        document.querySelector("[frist_error_message]").classList.add("d-none");
        document.querySelector("[second_error_message]").classList.add("d-none");
        document.querySelector("[data-error-wrap]").classList.add("d-none");

        selectedVariants.forEach(item => {
            let variantId = parseInt(item);
            if (firstArrayForFirstError.includes(variantId)) exist.first = true;
            if (secondArrayForFirstError.includes(variantId)) exist.second = true;
            if (firstArrayForSecondError.includes(variantId)) exist.third = true;
            if (secondArrayForSecondError.includes(variantId)) exist.fourth = true;
        });

        if (exist.third && exist.fourth) {
            document.querySelector("[second_error_message]").classList.remove("d-none");
            document.querySelector("[data-error-wrap]").classList.remove("d-none");
        } else if (exist.first && exist.second) {
            document.querySelector("[frist_error_message]").classList.remove("d-none");
            document.querySelector("[data-error-wrap]").classList.remove("d-none");
        }
    }
}


  _getMetafieldValue(){
    if (document.querySelector("[firstErrorMetafield]")) {
       let data = JSON.parse(document.querySelector("[firstErrorMetafield]").innerText);
       data.forEach(item=>{
        firstArrayForFirstError.push(parseInt(item.variant_id));
       });
       
    }
    if (document.querySelector("[firstErrorSecondMetafield]")) {
       let data = JSON.parse(document.querySelector("[firstErrorSecondMetafield]").innerText);
      data.forEach(item=>{
        secondArrayForFirstError.push(parseInt(item.variant_id));
       });
    }
    if (document.querySelector("[secondErrorMetafield]")) {
        let data = JSON.parse(document.querySelector("[secondErrorMetafield]").innerText);
        data.forEach(item=>{
          firstArrayForSecondError.push(parseInt(item.variant_id));
        });
    }
    if (document.querySelector("[secondErrorSecondMetafield]")) {
      let data =  JSON.parse(document.querySelector("[secondErrorSecondMetafield]").innerText);
      data.forEach(item=>{
        secondArrayForSecondError.push(parseInt(item.variant_id));
      });
    }
  }


  async setupSlider(ele){
    if( ele.hasAttribute('data-product-handle')){
      let handle = ele.getAttribute('data-product-handle');
    let requestURL = `/products/${handle}?sections=product-slider`;
    const response = await fetch(requestURL);
    const quickShopData = await response.json();
    let sliderData = quickShopData['product-slider'];
    document.querySelector("[data-slider-wrap]").innerHTML = sliderData;
    }
   
  }

}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
